module.exports = __webpack_public_path__ + "img/27_91.4cf1e3d7.png";